var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field-help" }, [
    _c(
      "a",
      {
        staticClass: "field-help__action-btn",
        attrs: { href: "javascript:;" },
        on: {
          click: function ($event) {
            _vm.visibleDropdown = !_vm.visibleDropdown
          },
        },
      },
      [_c("i", { staticClass: "fa fa-circle-question" })]
    ),
    _vm._v(" "),
    _vm.visibleDropdown
      ? _c("div", { staticClass: "field-help__dropdown dropdown-help" }, [
          _c(
            "div",
            { staticClass: "dropdown-help__header dropdown-help-header" },
            [
              _vm._t("header"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "close close-btn dropdown-help-header__close-btn",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      _vm.visibleDropdown = false
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-help__body dropdown-help-body" },
            [_vm._t("body")],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }